var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('StoreInformationForm'),_c('StoreSupportForm'),_c('StoreOwnerPhoneForm'),_c('ManageTagForm'),_c('StoreCustomFieldsForm'),_c('StoreDisableRegistrationsForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }